import { useState } from 'react';
import { Dayjs } from 'dayjs';
import { FeatureFlagHistoriesParams } from '../../../lib/api/featureFlag';

export const FLAG_HISTORY_PAGE_SIZE = 20;
export type FlagHistoryDateRange = [Dayjs | null, Dayjs | null] | null;

const ALL = 'all';

/** 조건은 「조회」를 눌러야 반영한다 — 고르는 동안 요청이 나가지 않게. 쪽 이동은 바로 반영 */
export const useFeatureFlagHistoryFilters = () => {
  const [ticketKey, setTicketKey] = useState<string>(ALL);
  const [dateRange, setDateRange] = useState<FlagHistoryDateRange>(null);
  const [applied, setApplied] = useState<Omit<FeatureFlagHistoriesParams, 'page' | 'pageSize'>>({});
  const [page, setPage] = useState(1);

  const apply = (): void => {
    setPage(1);
    setApplied({
      ...(ticketKey !== ALL ? { ticketKey } : {}),
      ...(dateRange?.[0] ? { fromDate: dateRange[0].format('YYYY-MM-DD') } : {}),
      ...(dateRange?.[1] ? { toDate: dateRange[1].format('YYYY-MM-DD') } : {}),
    });
  };
  const reset = (): void => {
    setTicketKey(ALL);
    setDateRange(null);
    setPage(1);
    setApplied({});
  };
  const params: FeatureFlagHistoriesParams = { ...applied, page, pageSize: FLAG_HISTORY_PAGE_SIZE };

  return { ticketKey, setTicketKey, dateRange, setDateRange, params, page, setPage, apply, reset, ALL };
};
